import { gql } from '@apollo/client'

export const GET_INVATION_DETAILS = gql`
  query getInvitationDetails($token: String!) {
    auth {
      getInvitationDetails(token: $token) {
        email
        fullName
        organizationName
        roles
      }
    }
  }
`

export const REGISTER_DEMO_ACCOUNT = gql`
  mutation createDemoAccount($input: CreateDemoAccountInput) {
    auth {
      createDemoAccount(input: $input) {
        user {
          token
        }
      }
    }
  }
`

export const REGISTER_BY_INVITE_LINK = gql`
  mutation acceptInvitation($input: AcceptInvitationInput!) {
    auth {
      acceptInvitation(input: $input) {
        token
      }
    }
  }
`

export const REGISTER_OWNER = gql`
  mutation signUp($input: RegisterOwnerInput!) {
    auth {
      registerOwner(input: $input) {
        token
      }
    }
  }
`

export const LOGIN_OWNER = gql`
  mutation signIn($input: UserSignInInput!) {
    auth {
      signIn(input: $input) {
        token
      }
    }
  }
`

export const CHANGE_PASSWORD = gql`
  mutation changePassword($input: ChangePasswordInput!) {
    auth {
      changePassword(input: $input) {
        token
      }
    }
  }
`

export const RESET_PASSWORD = gql`
  mutation resetPassword($input: ResetPasswordInput!) {
    auth {
      resetPassword(input: $input)
    }
  }
`

export const CONFIRM_RESET_PASSWORD = gql`
  mutation confirmResetPassword($input: ConfirmResetPasswordInput!) {
    auth {
      confirmResetPassword(input: $input) {
        token
      }
    }
  }
`
